import { JOB_OFFER_KIND_CODE_AND_QUERY } from 'constants/searchCondition';

/**
 * デフォルトの求人詳細リンク生成
 * @param jid 求人ID
 * @param isRead 既読判定
 * @param tp 求人種別
 * @returns デフォルトの求人詳細リンクURL
 */
export function createDefaultLinkForJobDetail(
  jid: string,
  isRead: boolean,
  tp?: string | undefined
) {
  return `/DodaFront/View/JobSearchDetail/j_jid__${jid}/-fm__list/-tp__${tp ?? JOB_OFFER_KIND_CODE_AND_QUERY.DEFAULT.query}/-mtmd__0/?from=list_${
    isRead ? 'browsed' : 'item'
  }`;
}
